import angular from 'angular';

const merchantDetailActionsFactory = function merchantDetailActionsFactory($rootScope, $q, $log, $http, Dispatcher, MerchantDetailService) {
    "ngInject";
    return {
      getMerchantDetail: function(userId, isBackground) {
        $log.debug("getMerchantDetailActions called");
        Dispatcher.dispatch({
          actionType: "MERCHANT_DETAIL_START_LOAD_ACTION",
          data: undefined,
          state: "STORE_PENDING_UPDATE"
        });
        MerchantDetailService.getMerchantDetail(userId, isBackground).then(function(result) {
          Dispatcher.dispatch({
            actionType: "MERCHANT_DETAIL_LOAD_ACTION",
            data: result,
            state: "STORE_VALID"
          });
          $log.debug('getMerchantDetail', 'dettagli', result);
        }, function(reason) {
          Dispatcher.dispatch({
            actionType: "MERCHANT_DETAIL_ACTION_FAIL",
            data: {},
            state: "STORE_FAILED_UPDATE"
          });
        });
      }
    };
  };

export default merchantDetailActionsFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantDetailActions.factory.js
 **/